import { Component, Input, OnInit } from '@angular/core';
import { SANCTION_LABELS } from "@app/ps/models/subject-detail.model";
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'sanction-tags',
  templateUrl: './sanction-tags.component.html',
  styleUrls: ['./sanction-tags.component.scss'],
})
export class SanctionTagsComponent implements OnInit {
  @Input() detail: any;

  isDisputed = false;
  activeTags: string[] = [];
  sourceDisputed = '';
  sanctionDetails: { label: string; value: SafeHtml }[] = [];

  constructor() {}

  ngOnInit(): void {
    this.activeTags = [];
    this.sanctionDetails = [];
    this.isDisputed = false;
    this.sourceDisputed = '';

    if (!this.detail) return;

    const {
      ssEU, ssNonEU, ssRuskyVliv,
      ssZpochybneni, ssZpochybneniRSD,
      ssDoporuceni, ssZpochybneniDuvod, ssZpochybneniRSDDuvod,
    } = this.detail;

    this.isDisputed = !!(ssZpochybneni || ssZpochybneniRSD);

    if (this.isDisputed) {
      this.sourceDisputed = ssZpochybneni && ssZpochybneniRSD ? 'DATLAB / ŘSD' :
        ssZpochybneni ? 'DATLAB' : 'ŘSD';
    }
    if (ssEU) { this.activeTags.push(SANCTION_LABELS.EU); }
    if (ssNonEU) { this.activeTags.push(SANCTION_LABELS.NON_EU); }
    if (ssRuskyVliv) { this.activeTags.push(SANCTION_LABELS.RUSSIAN_INFLUENCE); }

    if (ssDoporuceni) { this.sanctionDetails.push({ label: 'Doporučení:', value: ssDoporuceni }); }
    if (ssZpochybneniDuvod) { this.sanctionDetails.push({ label: 'Důvod zpochybnění:', value: ssZpochybneniDuvod }); }
    if (ssZpochybneniRSDDuvod) { this.sanctionDetails.push({ label: 'Důvod zpochybnění ŘSD:', value: ssZpochybneniRSDDuvod }); }
  }
}
